import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const BuyMeCoffee = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // URL du script officiel Ko-fi
    const scriptUrl = "https://storage.ko-fi.com/cdn/scripts/overlay-widget.js";
    
    // Vérification anti-doublon
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;

      script.onload = () => {
        // Une fois le script chargé, on initialise le widget
        // Ko-fi expose l'objet global 'kofiWidgetOverlay'
        if (window.kofiWidgetOverlay) {
          window.kofiWidgetOverlay.draw('thetugs', {
            'type': 'floating-chat',
            'floating-chat.donateButton.text': 'Support Me',
            'floating-chat.donateButton.background-color': '#00b9fe', // Bleu Ko-fi ou votre couleur
            'floating-chat.donateButton.text-color': '#fff'
          });
        }
      };
      
      document.head.appendChild(script);
    }

    // Pas de nettoyage simple possible car le script Ko-fi injecte une iframe 
    // qui ne se nettoie pas automatiquement via une API simple. 
    // Si nécessaire, on peut cibler l'ID spécifique créé par Ko-fi pour le supprimer.
    return () => {
      const kofiFrame = document.querySelector('[id^="kofi-widget-overlay"]');
      if (kofiFrame) kofiFrame.remove();
    };
  }, []);

  return null; // Le widget est flottant, pas besoin de rendu ici
};

export default BuyMeCoffee;
